import { useEffect, useRef, useState } from "react";
import { cn } from "~/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

interface TextOverflowProps extends React.HTMLAttributes<HTMLSpanElement> {
  autoTooltip?: boolean;
}

const TextOverflow = ({ autoTooltip, children, className, ...props }: TextOverflowProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    if (ref.current) {
      const isOverflowing = ref.current.scrollWidth > ref.current.clientWidth;
      setOverflowing(isOverflowing);
    }
  }, [children]);

  const tooltipEnabled = autoTooltip && overflowing;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span ref={ref} className={cn("truncate", className)} {...props}>
          {children}
        </span>
      </TooltipTrigger>
      {tooltipEnabled && <TooltipContent className="max-w-[750px]">{children}</TooltipContent>}
    </Tooltip>
  );
};

export { TextOverflow, type TextOverflowProps };
